module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_0.c8ebf6f4.mp3";